// src/registerServiceWorker.js

export function register() {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/wp-content/include-me/hotel_man_web/service-worker.js', {
                scope: '/wp-content/include-me/hotel_man_web/'
            }).then(reg => console.log('SW registered:', reg))
                .catch(err => console.error('SW registration failed:', err));
        });
    }
}
